export default __webpack_public_path__ + "static/media/PAAPI_REDDY.cf898d30.jpg";